import axios from 'axios';

// 创建 axios 实例
const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'https://www.limingsoftware.top/index.php/api', // 根据环境变量配置 API 基础路径
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json', // 默认请求头
  },
});

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么，例如添加 token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
http.interceptors.response.use(
  (response) => {
    // 对响应数据做些什么
    return response.data;
  },
  (error) => {
    // 对响应错误做些什么
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 处理未授权的情况
          break;
        case 404:
          // 处理未找到资源的情况
          break;
        default:
          // 处理其他错误
          break;
      }
    }
    return Promise.reject(error);
  }
);

// 封装 GET 请求
export const get = (url, params) => {
  return http.get(url, { params });
};

// 封装 POST 请求
export const post = (url, data) => {
  return http.post(url, data);
};

// 封装 PUT 请求
export const put = (url, data) => {
  return http.put(url, data);
};

// 封装 DELETE 请求
export const del = (url) => {
  return http.delete(url);
};

export default http;